<template>
  <div class="phantom-info" v-if="new_phantoms.length > 0">
    <div class="wrapper">
      <!-- <div class="phantom-nav"> -->
      <TxHScroll class="mb-16">
        <tx-btn
          :src="
            cur_key == b_index
              ? 'oldclassic_p_roleinfo_btn_ls_dis'
              : 'oldclassic_p_roleinfo_btn_ls_ovr'
          "
          v-for="(phantom, b_index) in new_phantoms"
          :key="b_index"
          :name="`元魂珠-${phantom['init_name']}`"
          @click="cur_key = b_index"
        >
          {{ phantom['init_name'] }}
        </tx-btn>
      </TxHScroll>
      <!-- </div> -->

      <div class="between-c">
        <div class="lNav">

        <tx-btn
          :src="
            cur_key2 == item.key
              ? 'oldclassic_m_roleinfo_btn_xiaoyeqian_dis'
              : 'oldclassic_m_roleinfo_btn_xiaoyeqian_nml'
          "
          v-for="item in sub_nav"
          :key="item.key"
          class="middle text-upright role-info-title-item"
          :class="{ 'role-info-title-item-act': cur_key2 == item.key }"
          :name="`元魂珠-${item.name}`"
          @click="cur_key2 = item.key"
          >{{item.name}} </tx-btn
        >
        </div>
        <tx-bg src="oldclassic_m_roleinfo_img_yhz_db" :size="bg_size">
          <!-- 基础 -->
          <jiChu v-if="cur_key2 == 0" :phantom="phantom" />
          <!-- 神通start -->
          <shenTong v-if="cur_key2 == 1" :phantom="phantom" />
          <!-- 化神start -->
          <!-- <huaShen v-if="cur_key2 == 2" :phantom="phantom" /> -->
        </tx-bg>
      </div>
    </div>
  </div>

  <div class="rEmpty" v-else>
    <div>该角色未吸收任何元魂珠</div>
  </div>
</template>

<script setup>
import { defineProps, ref, computed, inject } from 'vue';
import jiChu from './phantom_c/jiChu.vue';
import shenTong from './phantom_c/shenTong.vue';
import huaShen from './phantom_c/huaShen.vue';
const { yhz_img } = inject('filters');

const props = defineProps({
  role_data: {
    type: Object,
    default: () => ({}),
  },
});

const cur_key = ref(0);
const cur_key2 = ref(0);

const bg_size = ref({ width: 584, height: 1700 });
const sub_nav = ref([
  { name: '基础', key: 0 },
  { name: '神通', key: 1 },
]);

const phantom = computed(() => {
  return new_phantoms.value[cur_key.value] || {};
});

const new_phantoms = computed(() => {
  return props.role_data?.new_phantoms || [];
});
</script>